import type { PermissionRightKey } from '@/types/permissions';

interface PermissionRightPresentation {
  key: PermissionRightKey;
  labelKey: string;
  descriptionKey: string;
  badgeClassName: string;
}

const RIGHTS: Record<PermissionRightKey, PermissionRightPresentation> = {
  canRead: {
    key: 'canRead',
    labelKey: 'permissions.read',
    descriptionKey: 'permissions.readDescription',
    badgeClassName: 'border-primary/40 text-primary',
  },
  canWrite: {
    key: 'canWrite',
    labelKey: 'permissions.write',
    descriptionKey: 'permissions.writeDescription',
    badgeClassName: 'border-foreground/25 text-foreground',
  },
  canDelete: {
    key: 'canDelete',
    labelKey: 'permissions.delete',
    descriptionKey: 'permissions.deleteDescription',
    badgeClassName: 'border-destructive/40 text-destructive',
  },
  canShare: {
    key: 'canShare',
    labelKey: 'permissions.share',
    descriptionKey: 'permissions.shareDescription',
    badgeClassName: 'border-primary/25 text-primary/90',
  },
};

/** Badge order in the table. */
export const PERMISSION_RIGHT_BADGES: PermissionRightPresentation[] = [
  RIGHTS.canRead,
  RIGHTS.canWrite,
  RIGHTS.canDelete,
  RIGHTS.canShare,
];

/** Checkbox order in the dialog, which differs from the badge order. */
export const PERMISSION_RIGHT_FIELDS: PermissionRightPresentation[] = [
  RIGHTS.canRead,
  RIGHTS.canWrite,
  RIGHTS.canShare,
  RIGHTS.canDelete,
];
